import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { atlasRoutes } from "@/app/router/routes";
import { Table, TextField, Flex, Heading, Text } from "@radix-ui/themes";
import { RelativeTime } from "./components/relative-time";

export const MembotSessionsListPage: FC = () => {
  const sessions = useQuery(api.atlas.listSessions, { limit: 100 });
  const navigate = useNavigate();
  const [filter, setFilter] = useState("");

  const filtered = (sessions ?? []).filter((s) => {
    if (!filter) return true;
    const lc = filter.toLowerCase();
    return (
      s.sessionId.toLowerCase().includes(lc) ||
      (s.slackUserName ?? "").toLowerCase().includes(lc) ||
      (s.slackUserEmail ?? "").toLowerCase().includes(lc) ||
      s.slackUserId.toLowerCase().includes(lc)
    );
  });

  return (
    <div>
      <Flex justify="between" align="center" mb="4">
        <Heading size="5">Membot Sessions</Heading>
        <Text size="2" color="gray">
          {sessions === undefined ? "Loading..." : `${filtered.length} sessions`}
        </Text>
      </Flex>

      <TextField.Root
        placeholder="Filter by name, email, session ID, or slack user ID..."
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        mb="4"
      />

      {sessions === undefined ? (
        <Text color="gray">Loading sessions...</Text>
      ) : (
        <Table.Root variant="surface">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeaderCell>User</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell>Slack User ID</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell>Session ID</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell>Team</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell>Created</Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell>Updated</Table.ColumnHeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {filtered.map((session) => (
              <Table.Row
                key={session._id}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(
                    atlasRoutes.membotView({
                      params: { sessionId: session.sessionId },
                    }).path
                  )
                }
              >
                <Table.Cell>
                  <div>
                    <Text weight="medium">{session.slackUserName ?? "—"}</Text>
                    {session.slackUserEmail && (
                      <Text size="1" color="gray" as="div">
                        {session.slackUserEmail}
                      </Text>
                    )}
                  </div>
                </Table.Cell>
                <Table.Cell>
                  <Text size="1" style={{ fontFamily: "monospace" }}>
                    {session.slackUserId}
                  </Text>
                </Table.Cell>
                <Table.Cell>
                  <Text
                    size="1"
                    color="blue"
                    style={{ fontFamily: "monospace", cursor: "pointer" }}
                  >
                    {session.sessionId.slice(0, 12)}...
                  </Text>
                </Table.Cell>
                <Table.Cell>
                  <Text size="1" style={{ fontFamily: "monospace" }}>
                    {session.teamId}
                  </Text>
                </Table.Cell>
                <Table.Cell>
                  <RelativeTime timestamp={session.createdAt} />
                </Table.Cell>
                <Table.Cell>
                  <RelativeTime timestamp={session.updatedAt} />
                </Table.Cell>
              </Table.Row>
            ))}
            {filtered.length === 0 && (
              <Table.Row>
                <Table.Cell colSpan={6}>
                  <Text color="gray" align="center">
                    {filter ? "No sessions match the filter." : "No sessions found."}
                  </Text>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table.Root>
      )}
    </div>
  );
};
